import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-search-bar',
  templateUrl: './mobile-search-bar.component.html',
  styleUrls: ['./mobile-search-bar.component.scss'],
})
export class MobileSearchBarComponent {}
